import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import { BLACK } from '../../styles/variables.style';

import QuickLinksSection from '../../components/QuickLinksSection';
import InspirationOverview from './InspirationOverview/InspirationOverview';
import InspirationSection from './InspirationSection/InspirationSection';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import Placeholder from '../../components/Placeholder';
import { TABLET_L } from '../../constants';

const Wrapper = styled.div`
  color: ${BLACK};
`;

const InspirationPage = ({ data, locale, menuInfo }) => {
  const quickLinks = data.sections
    .filter(section => section.quickLinkLabel)
    .map(link => ({ id: link.entryId, label: link.quickLinkLabel }));

  return (
    <Wrapper>
      {_.get(data, 'metaData') && (
        <Helmet
          title={_.get(data.metaData, 'title')}
          link={[
            makeCanonicalTagObj(locale, '/inspiration'),
            ...makeHreflangTagArr(data.metaData.region, '/inspiration'),
          ]}
          meta={[
            {
              name: 'description',
              content: _.get(data.metaData, 'description'),
            },
            {
              name: 'keyword',
              content: _.get(data.metaData, 'keyword'),
            },
            // TODO: OGP タグは一旦保留 (2020年01月07日)
            // {
            //   property: 'og:url',
            //   content: _.get(data.metaData, 'url'),
            // },
            // {
            //   property: 'og:type',
            //   content: _.get(data.metaData, 'type'),
            // },
            // {
            //   property: 'og:title',
            //   content: _.get(data.metaData, 'title'),
            // },
            // {
            //   property: 'og:image',
            //   content: _.get(data.metaData, 'image.file.url'),
            // },
            // {
            //   property: 'og:description',
            //   content: _.get(data.metaData, 'description'),
            // },
            // {
            //   property: 'og:site_name',
            //   content: _.get(data.metaData, 'siteName'),
            // },
          ]}
        />
      )}
      <QuickLinksSection links={quickLinks} />

      <InspirationOverview heroImage={data.heroImage} title={data.title} description={data.description} />

      {data.sections
        .filter(section => section.entry)
        .map((section, idx) => (
          <InspirationSection key={section.entryId || section.key} copy={data.copy} content={section} index={idx} />
        ))}

      <ScrollToTopButton />

      {!(locale && menuInfo && _.get(menuInfo, 'label')) ? (
        <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_L ? '0 0 20px 40px' : '0 0 20px 20px'} />
      ) : (
        <BreadCrumbMenu
          currentPath={`https://www.shiseido-professional.com/${locale}/inspiration`}
          items={[
            {
              name: 'TOP',
              path: `/${locale}/`,
            },
            {
              name: menuInfo.label,
              path: null,
            },
          ]}
        />
      )}
    </Wrapper>
  );
};

InspirationPage.defaultProps = {
  data: {
    copy: {},
    notLoaded: true,
    sections: [{ key: 0, entry: {} }, { key: 1, entry: {} }],
  },
};

InspirationPage.propTypes = {
  locale: PropTypes.string.isRequired,
  // INSPIRATION (クリエイション) メニュー情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
  data: PropTypes.shape(),
};

const mapState = state => ({
  // INSPIRATION (クリエイション) メニュー情報をキャッシュしておく
  menuInfo: state.siteOptions.menu ? state.siteOptions.menu[1] : {},
});

export default connect(mapState)(InspirationPage);



// WEBPACK FOOTER //
// ./src/pages/InspirationPage/InspirationPage.js